import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchActivities } from '../../actions/configs';
import { fetchTrainers } from '../../actions/users';
import { createAppointment } from '../../actions/appointments';
import viewHelper from '../../helpers/view';
import Spinner from '../shared/spinner';
import SelectActivity from './selectActivity';
import SelectTrainer from './selectTrainer';
import SelectDateTime from './selectDateTime';
import ConfirmAppointment from './confirmAppointment';
import ShowAppointment from './showAppointment';
import MemberInfo from '../shared/memberInfo';

class BookAppointment extends Component {

    constructor(props) {
        super(props);
        this.state = { activity: null, trainer: null, date: null, startTime: null, endTime: null, confirm: false };
    }

    componentDidMount() {
        this.props.fetchActivities(false, null, {filter: 'schedule'}).then(() => {
            this.props.fetchTrainers();
        });
    }

    updateComponent(state) {
        if(state.activity && state.trainer && state.date && state.startTime && state.endTime && state.confirm) {
            this.props.createAppointment({
                activity_id: state.activity.id,
                trainer_id: state.trainer.id,
                date: viewHelper.getFormattedDate(state.date),
                start_time: state.startTime,
                end_time: state.endTime
            }, this.props.history);
        }
        return this.setState(state);
    }

    selectActivity() {
        this.setState({ activity: null, trainer: null, date: null, startTime: null, endTime: null, confirm: false });
    }

    selectTrainer() {
        this.setState({ activity: this.state.activity, trainer: null, date: null, startTime: null, endTime: null, confirm: false });
    }

    selectDateTime() {
        this.setState({ activity: this.state.activity, trainer: this.state.trainer, date: null, startTime: null, endTime: null, confirm: false });
    }

    getSelectedComponent() {
        if(this.props.spinner) return Spinner;

        if (!this.state.activity) return SelectActivity;
        else if (this.state.activity && !this.state.trainer) return SelectTrainer;
        else if (this.state.trainer && !this.state.date) return SelectDateTime;
        else if (this.state.date && !this.state.confirm) return ConfirmAppointment;
        else if (this.state.confirm && !this.props.appointment) return ConfirmAppointment;
        else if (this.props.appointment) return ShowAppointment;
    }

    getActivityTitle() {
        let title;
        if(this.state.activity) {
            title = <div className='selection small cursor' onClick={this.selectActivity.bind(this)}>{this.state.activity.description}</div>;
        } else {
            title = <div className='selection small'>Selecting Service</div>;
        }

        return (
            <div className='step-title'>
                <div className='header'>1. Service</div>
                {title}
            </div>
        );
    }

    getTrainerTitle(currentStep) {
        let title;
        if(this.state.trainer) {
            title = <div className='selection small cursor' onClick={this.selectTrainer.bind(this)}>{viewHelper.getFullName(this.state.trainer)}</div>;
        } else {
            title = currentStep ? <div className='selection small'>Selecting Staff</div> : '';
        }
        return (
            <div className='step-title'>
                <div className='header'>2. Staff</div>
                {title}
            </div>
        );
    }

    getDateTimeTitle(currentStep) {
        let title;
        if(this.state.date) {
            title = <div className='selection small cursor' onClick={this.selectDateTime.bind(this)}>{viewHelper.getFormattedDate(this.state.date)} {this.state.startTime}</div>;
        } else {
            title = currentStep ? <div className='selection small'>Selecting Date</div> : '';
        }
        return (
            <div className='step-title'>
                <div className='header'>3. Date & Time</div>
                {title}
            </div>
        );
    }

    getConfirmationTitle(currentStep) {
        let title;
        if(this.state.confirm) {
            title = <div className='selection small'>Confirmed</div>;
        } else {
            title = currentStep ? <div className='selection small'>Confirm Your Selections</div> : '';
        }
        return (
            <div className='step-title'>
                <div className='header'>4. Confirm</div>
                {title}
            </div>
        );
    }

    getCompletedTitle() {
        return (
            <div className='step-title'>
                <div className='header'>5. Completed</div>
            </div>
        );
    }

    render () {
        const { member, activities, trainers, appointment } = this.props;
        if(!activities || !trainers) {
            return (
                <div className="container content">
                    <Spinner />
                </div>
            );
        } else {
            let SelectedComponent = this.getSelectedComponent();
            return (
                <div className="container content">
                    <MemberInfo title={`${viewHelper.getFullName(member)} - Book Appointment`} />

                    <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                        <div className="row-eq-height">
                            <div className="col-xs-12 col-md-3 col-lg-3 filters steps">
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className="active">{this.getActivityTitle()}</blockquote>
                                </div>
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className={this.state.activity ? 'active' : ''}>{this.getTrainerTitle(this.state.activity)}</blockquote>
                                </div>
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className={this.state.trainer ? 'active' : ''}>{this.getDateTimeTitle(this.state.trainer)}</blockquote>
                                </div>
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className={this.state.date ? 'active' : ''}>{this.getConfirmationTitle(this.state.date && !this.props.appointment)}</blockquote>
                                </div>
                                <div className="col-md-12 col-sm-6 col-xs-12">
                                    <blockquote className={this.props.appointment ? 'active' : ''}>{this.getCompletedTitle()}</blockquote>
                                </div>
                                <div className='col-md-12 small col-xs-12'>*You Can Edit Your Selections At Any Step By Clicking On It.</div>
                            </div>
                            <div className="col-xs-12 col-md-9 col-lg-9 no-padding pt-15 pb-15 border-bottom">
                                <SelectedComponent {...this.state}
                                                   activities={activities}
                                                   trainers={trainers}
                                                   appointment={appointment}
                                                   callbackToUpdateComponent={this.updateComponent.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    const { activities, trainers, appointment, spinner } = state;
    return {
        activities,
        trainers,
        appointment,
        spinner
    };
}

export default connect(mapStateToProps, {
    fetchActivities: fetchActivities,
    fetchTrainers: fetchTrainers,
    createAppointment: createAppointment })(BookAppointment);



// WEBPACK FOOTER //
// ./src/components/appointments/bookAppointment.js